/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElTable as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "marginB10"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "marginB20"
}, "请前往渠道后台获取ID后配置此处对应商品中。此处只能关联商品ID，如需新增或修改商品信息，请前往“游戏通用商品管理”", -1);
const _hoisted_3 = {
  class: "flex justify-between marginB10"
};
import { apiUsdkGetGoodsConfEdit } from '@/api/usdk';
import UseGoodsHook, { UsePropConfig } from './goodsHooks';
import { UseGlobalConfig } from '@/utils/hooks';
import { exportExcel } from '@/utils/util';
import InputComponent from './modules/input';
export default /*#__PURE__*/_defineComponent({
  __name: 'internalGoods',
  props: UsePropConfig(),
  setup(__props) {
    const {
      $channel
    } = UseGlobalConfig();
    const props = __props;
    const filterVal = ref(['goodsId', 'goodsName', 'price', 'currency', 'goodsDesc']);
    watch(() => props.channel, channel => {
      if (channel.cid) {
        filterVal.value.push(channel.channel === $channel.OFFICIAL_IOS_CHANNEL ? 'iosGoodsId' : 'channelGoodsId');
      }
    }, {
      immediate: true
    });
    const {
      // propsConfig,
      confirmLoading,
      tableData,
      loadingTable,
      isEdit,
      oldTableData,
      handleEditGoods,
      handlePatchInputClick,
      handleFileChange,
      inputRef
    } = UseGoodsHook(filterVal.value, props, 1, 'internal');
    const getGoodsConf = () => {
      loadingTable.value = true;
      apiUsdkGetGoodsConfEdit({
        gid: props.gid,
        cid: props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          oldTableData.value = JSON.parse(JSON.stringify(res.data));
        }
      }).finally(() => {
        loadingTable.value = false;
      });
    };
    const exportGoods = () => {
      const header = ['游戏商品ID', '商品名称', '商品金额(元)', '币种', '商品描述', props.channel.channel === $channel.OFFICIAL_IOS_CHANNEL ? 'AppStore商品ID' : `${props.channel.name}商品ID`];
      exportExcel(header, filterVal.value, tableData.value, `${new Date().toLocaleString()}_${props.channel.name}商品配置`);
    };
    onMounted(() => {
      getGoodsConf();
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_table_column = __unplugin_components_1;
      const _component_el_table = __unplugin_components_2;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        disabled: _unref(tableData).length == 0,
        onClick: exportGoods
      }, {
        default: _withCtx(() => [_createTextVNode("导出商品")]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        class: "marginL10",
        type: "primary",
        onClick: _unref(handlePatchInputClick)
      }, {
        default: _withCtx(() => [_createTextVNode("导入商品")]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        loading: _unref(confirmLoading),
        onClick: _unref(handleEditGoods),
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(isEdit) ? '保存商品' : '编辑商品'), 1)]),
        _: 1
      }, 8, ["loading", "onClick"])])])]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(tableData)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          key: "goodsId",
          label: "游戏商品ID",
          prop: "goodsId"
        }), _createVNode(_component_el_table_column, {
          key: "goodsName",
          label: "商品名称",
          prop: "goodsName"
        }), _createVNode(_component_el_table_column, {
          key: "price",
          label: "商品金额(元)",
          prop: "price"
        }), _createVNode(_component_el_table_column, {
          key: "currency",
          label: "币种",
          prop: "currency",
          width: "100px"
        }), _createVNode(_component_el_table_column, {
          key: "goodsDesc",
          label: "商品描述",
          prop: "goodsDesc"
        }), _ctx.channel.channel === _unref($channel).OFFICIAL_IOS_CHANNEL ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          width: "200px",
          label: "AppStore商品ID"
        }, {
          default: _withCtx(scope => [_createVNode(_unref(InputComponent), {
            disabled: !_unref(isEdit),
            modelValue: scope.row.iosGoodsId,
            "onUpdate:modelValue": $event => scope.row.iosGoodsId = $event
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_table_column, {
          key: "channelGoodsId",
          label: (_ctx.channel.channel && _ctx.channel.name) + '商品ID',
          prop: "channelGoodsId",
          width: "250px"
        }, {
          default: _withCtx(scope => [_createVNode(_unref(InputComponent), {
            disabled: !_unref(isEdit),
            modelValue: scope.row.channelGoodsId,
            "onUpdate:modelValue": $event => scope.row.channelGoodsId = $event
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])]),
          _: 1
        }, 8, ["label"]))]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, _unref(loadingTable)]]), _createElementVNode("input", {
        type: "file",
        accept: ".xls,.xlsx",
        ref_key: "inputRef",
        ref: inputRef,
        multiple: false,
        onChange: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(handleFileChange) && _unref(handleFileChange)(...args)),
        style: {
          "display": "none"
        }
      }, null, 544)], 64);
    };
  }
});